// libraries
import clsx from 'clsx'

// types
export interface TableProps {
    className?: string
    list?: {
        title?: string
        content?: string
    }[]
}

// css
import './index.scss'

export default function Table({
    className,
    list
}: TableProps) {
    return (
        <div className={clsx('table-component', className)}>
            <ul>
                {list?.map((item, i) => (
                    <li
                        key={i}
                        className='body'
                    >

                        <p className='table-component__title'>
                            {item.title}
                        </p>

                        <div
                            dangerouslySetInnerHTML={{ __html: item.content || ''}}
                            suppressHydrationWarning
                            className='table-component__content'
                        />

                    </li>
                ))}
            </ul>
        </div>
    )
}